export default "__VITE_ASSET__DI0zBDis__"